import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedManufacturerSelector($companyId: ID!) {
    assetTypes(companyId: $companyId) {
      manufacturers
    }
  }
`
